import React from 'react';
import { motion } from 'framer-motion';
import { CheckCircle, Circle, Clock } from 'lucide-react';

const Milestone = ({ status, title, date, description }) => {
  const isCompleted = status === 'completed';
  const isProgress = status === 'in_progress';

  return (
    <div className="flex gap-4">
      <div className="flex flex-col items-center">
        <div className={`w-8 h-8 rounded-full flex items-center justify-center shrink-0 border-2 ${
          isCompleted ? 'bg-emerald-500/20 border-emerald-500 text-emerald-500' : 
          isProgress ? 'bg-primary/20 border-primary text-primary' : 
          'bg-white/5 border-slate-600 text-slate-600'
        }`}>
          {isCompleted ? <CheckCircle size={16} /> : isProgress ? <Clock size={16} /> : <Circle size={16} />}
        </div>
        <div className="w-0.5 flex-1 bg-white/10 my-2" />
      </div>
      <div className="pb-8">
        <div className="flex items-center gap-3 mb-1">
          <h3 className={`font-bold text-lg ${isCompleted ? 'text-white' : 'text-slate-300'}`}>{title}</h3>
          {date && <span className="text-xs font-mono text-slate-500 px-2 py-0.5 rounded bg-white/5">{date}</span>}
        </div>
        <p className="text-slate-400 text-sm max-w-lg leading-relaxed">{description}</p>
      </div>
    </div>
  );
};

export default function Roadmap() {
  return (
    <div className="max-w-3xl mx-auto space-y-8">
      <div>
        <h1 className="text-3xl font-bold text-white mb-2">Roadmap проекта</h1>
        <p className="text-slate-400">Планы по развитию функционала сервиса аналитики.</p>
      </div>

      <div className="bg-surface p-8 rounded-2xl border border-white/5">
        <Milestone 
          status="completed" 
          title="Базовая аналитика" 
          date="Q1 2024"
          description="Запуск сбора статистики подписчиков, просмотров и базового вовлечения. Интеграция с Telegram Bot API."
        />
        <Milestone 
          status="completed" 
          title="Сквозная аналитика (Funnel)" 
          date="Q2 2024"
          description="Отслеживание пути пользователя от клика по реферальной ссылке до покупки. Визуализация воронки продаж."
        />
        <Milestone 
          status="in_progress" 
          title="Расширенная отчетность" 
          date="Q3 2024"
          description="Генерация PDF/CSV отчетов, автоматическая отправка дайджестов на почту, детальный анализ контента."
        />
        <Milestone 
          status="pending" 
          title="AI Предиктивная аналитика" 
          date="Q4 2024"
          description="Прогнозирование роста канала и выручки на основе исторических данных с использованием машинного обучения."
        />
        <Milestone 
          status="pending" 
          title="Мобильное приложение" 
          date="2025"
          description="Нативное приложение для iOS и Android для управления каналами на ходу."
        />
      </div>
    </div>
  );
}
